import { __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { featuresMap } from './constants';
import { WixStyleReactContext } from './context';
import { classes, st } from '../typography.st.css';
import { classes as newColorsBrandingClasses } from './newColorsBranding.st.css';
import { classes as colorsWithoutThemeClasses } from '../colors.st.css';
import { classes as madeforClasses } from './madefor.st.css';
/** Wix Style React Provider */
const WixStyleReactProvider = (_a) => {
    var { dataHook, className, as, children, features, typographyClass } = _a, rest = __rest(_a, ["dataHook", "className", "as", "children", "features", "typographyClass"]);
    return (React.createElement(WixStyleReactContext.Provider, { value: Object.assign({ newBrandingClass: features[featuresMap.newColorsBranding] &&
                newColorsBrandingClasses.root }, features) }, React.createElement(as, Object.assign(Object.assign({}, rest), { 'data-hook': dataHook, className: st(classes.root, typographyClass, className, features[featuresMap.newColorsBranding]
            ? newColorsBrandingClasses.root
            : colorsWithoutThemeClasses.root, madeforClasses.madefor) }), children)));
};
WixStyleReactProvider.displayName = 'WixStyleReactProvider';
WixStyleReactProvider.propTypes = {
    /** Applied as data-hook HTML attribute that can be used to create driver in testing */
    dataHook: PropTypes.string,
    /** A css class to be applied to the component's root element */
    className: PropTypes.string,
    /** render as some other component or DOM tag */
    as: PropTypes.oneOf(['span', 'div']),
    /** A renderable node */
    children: PropTypes.node,
    /** Object which represent all features you would like to use. The available features are:
     * - `newColorsBranding`: new business dashboard colors
     * - `sidebarExperimentCollapsible`: sidebar component experiment to enable collapsible feature.
     * */
    features: PropTypes.shape({
        newColorsBranding: PropTypes.bool,
        sidebarExperimentCollapsible: PropTypes.bool,
    }),
};
WixStyleReactProvider.defaultProps = {
    as: 'span',
    features: {},
};
export default WixStyleReactProvider;
//# sourceMappingURL=WixStyleReactProvider.js.map